import React, { useEffect } from 'react';
import { RadioButtonChecked } from '@mui/icons-material';
import moment from 'moment';
type Moment = moment.Moment;

interface LiveSessionIndicatorProps {
  startTime: Moment;
  duration: number; // duration in minutes
  elapsedTime: string;
  setElapsedTime: React.Dispatch<React.SetStateAction<string>>;
}

const LiveSessionIndicator: React.FC<LiveSessionIndicatorProps> = ({ elapsedTime, setElapsedTime, startTime, duration }) => {
  // const [elapsedTime, setElapsedTime] = useState<string>('00:00:00');

  useEffect(() => {
    const timer = setInterval(() => {
      const now = moment();
      const endTime = moment(startTime).add(duration, 'minutes');
      
      // If current time is before start time, show 00:00:00
      if (now.isBefore(startTime)) {
        setElapsedTime('00:00:00');
        return;
      }
      
      // If current time is after end time, show the full duration
      if (now.isAfter(endTime)) {
        const hours = Math.floor(duration / 60);
        const minutes = duration % 60;
        setElapsedTime(
          `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`
        );
        return;
      }
      
      // Calculate elapsed time between start and now
      const diff = now.diff(startTime, 'seconds');
      const hours = Math.floor(diff / 3600);
      const minutes = Math.floor((diff % 3600) / 60);
      const seconds = diff % 60;
      
      setElapsedTime(
        `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
      );
    }, 1000);

    return () => clearInterval(timer);
  }, [startTime, duration, elapsedTime, setElapsedTime]);

  return (
    <div className="flex items-center space-x-2 bg-green-50 px-3 py-1.5 rounded-full">
      <div className="relative">
        <RadioButtonChecked 
          className="text-green-500 animate-pulse" 
          style={{ animationDuration: '1.5s' }}
        />
        <div className="absolute inset-0 bg-green-500 rounded-full opacity-20 animate-ping" 
             style={{ animationDuration: '1.5s' }} />
      </div>
      <span className="text-green-600 font-medium">Live</span>
      <span className="text-gray-600 font-mono">{elapsedTime}</span>
    </div>
  );
};

export default LiveSessionIndicator; 